// noinspection JSDeprecatedSymbols

import bsBreakpoints from "bs-breakpoints";

if (!Object.entries) {
  Object.entries = function( obj ){
    let ownProps = Object.keys( obj ),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    
    return resArray;
  };
}

$(window).on('new.bs.breakpoint', function (e) {
    // re-detect current breakpoint
    bsBreakpoints.detectBreakpoint();
    replaceHeaderItems(bsBreakpoints);
    prepareHeaderShortcuts(bsBreakpoints);
    setSearchRole(bsBreakpoints);
});

$(document).ready(function() {
    // init breakpoint determination
    bsBreakpoints.init();

    // set up header and menus
    replaceHeaderItems(bsBreakpoints);
    prepareHeaderShortcuts(bsBreakpoints);
    setSearchRole(bsBreakpoints);

    // function for drill-down-menu
    $("#categoryMenu > .nav.is-drilldown")
        .on("click", ".nav-dropdown-toggle", function(e) {
            let submenu = $(this).parent('li').children('.nav-dropdown-items').first();
            submenu.addClass('visible');
            $(this).attr({'aria-expanded': true});
        })
        .on("click", ".nav-drilldown-back", function(e) {
            let menu = $(this).parent('li').parent('.nav-dropdown-items').first();
            menu.removeClass('visible');
            menu.prev('.nav-dropdown-toggle').attr({'aria-expanded': false});
        });


    // prepare general ui elements
    prepareCustomInputs();

    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    })

    addWaveRipples();
});

function prepareCustomInputs() {
    $('.custom-file-input').on('change', function() {
        let fileName = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').html(fileName);
    })
}

function addWaveRipples() {
    $('.btn').not('.btn-link').on('click', createRipple);

    function createRipple(e) {
        let children = this.getElementsByClassName('wave-ripple');
        while(children.length > 0) {
            children[0].parentNode.removeChild(children[0]);
        }

        let circle = document.createElement('div');
        circle.style["position"] = 'absolute';
        this.appendChild(circle);

        let d = Math.max(this.clientWidth, this.clientHeight);
        let eRect = this.getBoundingClientRect()

        circle.style.width = circle.style.height = d + 'px';
        circle.style.left = e.clientX - eRect.left - d / 2 + 'px';
        circle.style.top = e.clientY - eRect.top - d / 2 + 'px';

        circle.classList.add('wave-ripple');
    }
}

window.focusError=function(id) {
    let headerHeight = parseInt($('#pageHeader').outerHeight()),
        indent = 32, // 2rem
        element = $('#'+id);

    $('html, body').animate({ scrollTop: (element.offset().top - indent - headerHeight) }, 'slow');
    element.focus();
}

function replaceHeaderItems(bsBreakpoints) {
    if( bsBreakpoints.getCurrentBreakpoint() === 'medium' || bsBreakpoints.getCurrentBreakpoint() === 'small' || bsBreakpoints.getCurrentBreakpoint() === 'xSmall') {
        $('#profile-menu').detach().appendTo( '#subbar-menu' );
        $('#account-buttons').detach().prependTo( '#subbar-menu' );
    } else {
        $('#profile-menu').detach().appendTo( '#header-right' );        
        $('#account-buttons').detach().appendTo( '#header-right' );        
    }
    $('#profile-menu').removeClass('d-none');
    $('#account-buttons').removeClass('d-none');
}

function prepareHeaderShortcuts(bsBreakpoints) {
    let items = document.querySelectorAll("#header-right > .shortcut-item");

    items.forEach(el => {
        if( bsBreakpoints.getCurrentBreakpoint() === 'medium' || bsBreakpoints.getCurrentBreakpoint() === 'small' || bsBreakpoints.getCurrentBreakpoint() === 'xSmall') {
            el.classList.remove('mega-dropdown');
        } else {
            el.classList.add('mega-dropdown');
        }
    });
}


function setSearchRole(sbBreakpoints) {
    if( bsBreakpoints.getCurrentBreakpoint() === 'medium' || bsBreakpoints.getCurrentBreakpoint() === 'small' || bsBreakpoints.getCurrentBreakpoint() === 'xSmall') {
        $('#mobileSearch').attr( 'role', 'search' );
        $('#desktopSearch').removeAttr('role')
    } else {
        $('#desktopSearch').attr('role', 'search');
        $('#mobileSearch').removeAttr('role')
    }
}